// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-column-actions button + button {
  margin-left: var(--spacing-small);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user/users-list/users-list.component.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;AACF","sourcesContent":[".mat-column-actions button + button {\n  margin-left: var(--spacing-small);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
